var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_3771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.0800781C10.933 0.0800781 10.8694 0.0903908 10.8075 0.121328L0.2475 5.40133C0.0979686 5.47695 0 5.63336 0 5.80008C0 5.9668 0.0979686 6.1232 0.2475 6.19883L1.76 6.95508V13.3626C1.25125 13.5465 0.88 14.0277 0.88 14.6001C0.88 15.1604 1.55375 16.1899 1.8425 16.6076L2.2 17.1301L2.5575 16.6076C2.84625 16.1899 3.52 15.1604 3.52 14.6001C3.52 14.0277 3.14875 13.5465 2.64 13.3626V7.39508L3.52 7.83508V6.68008C3.52 5.15383 5.71656 4.84445 6.655 4.71383C8.06953 4.51789 9.79859 4.48008 11 4.48008C12.2014 4.48008 13.9305 4.51789 15.345 4.71383C16.2834 4.84445 18.48 5.15383 18.48 6.68008V7.83508L21.7525 6.19883C21.902 6.12492 22 5.9668 22 5.80008C22 5.63336 21.902 5.47695 21.7525 5.40133L11.1925 0.121328C11.1306 0.0903908 11.067 0.0800781 11 0.0800781ZM11 5.36008C8.53531 5.36008 4.4 5.53195 4.4 6.68008V8.72883C5.31437 8.33867 7.18094 8.00008 11 8.00008C14.8191 8.00008 16.6856 8.33867 17.6 8.72883V6.68008C17.6 5.53195 13.4647 5.36008 11 5.36008ZM11 8.88008C6.42812 8.88008 4.52719 9.41805 4.4 9.76008C4.40688 10.9048 8.53703 11.0801 11 11.0801C13.4114 11.0801 17.4127 10.9116 17.5863 9.82883C17.5914 9.80305 17.6 9.78586 17.6 9.76008C17.4814 9.4232 15.5822 8.88008 11 8.88008Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_3771",
    x: -4,
    y: 0.0800781,
    width: 30,
    height: 25.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_3771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_3771",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.3ca55a09c658278161111f65f26fab17.svg";
export { ForwardRef as ReactComponent };